export default function (instance) {
  return {
    getProduct ({ bundleName, promotionCode, replenishmentQuantity }) {
      return instance
        .get('/api/bundle/details', {
          params: {
            bundleName,
            promotionCode,
            replenishmentQuantity
          }
        })
        .then(response => response.data)
    },

    getBanners (bundles) {
      return instance
        .get('/api/bundle/banner', {
          params: {
            bundles
          }
        })
        .then(response => response.data)
    },

    getFaq () {
      return instance
        .get('/api/bundle/faq')
        .then(response => response.data)
    }
  }
}
